module.exports = __webpack_public_path__ + "static/media/202.63106f50.mp3";